import axios from 'axios'
import { processPrize } from './index'

export const WIN_STATUSES = {
  READY_TO_CLAIM: 1,
  CLAIMED: 2,
  COMPLETE: 3,
}

// state
export const state = {
  unseenWins: [],
  isHowToPlayVisible: false,
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  fetchUnseenWinsStart(state) {
    state.isUnseenWinsLoading = true
  },
  fetchUnseenWinsSuccess(state, { wins }) {
    state.unseenWins = wins.map(prize => processPrize(prize))
    state.isUnseenWinsLoading = false
  },
  fetchUnseenWinsFailed(state) {
    state.isUnseenWinsLoading = false
  },
}
// actions
export const actions = {
  async fetchUnseenWins({ commit }) {
    commit('fetchUnseenWinsStart')
    try {
      const wins = await axios.get(`wins/unseen`)
      commit('fetchUnseenWinsSuccess', { wins })
    } catch (error) {
      commit('fetchUnseenWinsFailed')
    }
  },
  async markSeenWins({ commit, state }) {
    await axios.post(`wins/markSeen`, {
      wins: state.unseenWins.map(win => win.id),
    })
    commit('fetchUnseenWinsSuccess', { wins: [] })
  },
  async claimReward({ commit }, { winId }) {
    try {
      const { win } = await axios.post(`wins/claimPrize/${winId}`)
      if (win) {
        commit('prizes/index/setPrizeStatus', {
          prizeId: win.id,
          status: win.status,
        }, { root: true })
      }
      return win
    } catch (error) {
      return error
    }
  },
}
